var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"locked-header"},[(_vm.showPracticeBanner)?_c('div',{staticClass:"practice-banner"},[_c('Icon',{staticClass:"fitted practice-banner-icon",attrs:{"value":"banner-alert"}}),_c('p',[_vm._v("Practice Mode | Not to be used in training")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }